module.exports = __webpack_public_path__ + "static/img/342_phase_function_Paper_PointsHejduk_Prediction.ba9b1ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/342_phase_function_Paper_PointsHejduk_Prediction.png
// module id = EdY5
// module chunks = 0